import { render, staticRenderFns } from "./linked-entities.vue?vue&type=template&id=7b889a64"
import script from "./linked-entities.vue?vue&type=script&lang=js"
export * from "./linked-entities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports